/**
 * Small components the shell surface references, lifted out of App.tsx.
 *
 * Phase 3 Package 1 (.claude/specs/module-ui-rollout.md). The generated
 * shellConfig.tsx references these in nav labels and route elements, and App.tsx
 * still uses them too, so they cannot stay private to App.tsx.
 *
 * Moved verbatim — no behaviour change. Anything larger stays where it is; this
 * is only the handful of leaf components the config needs to name.
 */
import React from "react";
import { useSearchParams } from "react-router-dom";

import OffersPage from "../pages/OffersPage";
import SalarySlipsPage from "../pages/SalarySlipsPage";

export function NotFound() {
  return (
    <div style={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#64748b" }}>
      <div style={{ fontSize: 48, fontWeight: 700, color: "#e2e8f0" }}>404</div>
      <div style={{ fontSize: 16, marginTop: 8 }}>Page not found</div>
      <a href="/" style={{ marginTop: 16, fontSize: 14, color: "#1e3a8a", textDecoration: "none" }}>← Go to Dashboard</a>
    </div>
  );
}

export function EmployeeSlipsView() {
  return <SalarySlipsPage employeeOnly />;
}

export function NavBadge({ label, count, color = "#f59e0b" }: { label: string; count?: number; color?: string }) {
  return (
    <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
      {label}
      {count != null && count > 0 && (
        <span style={{
          background: color, color: "white", borderRadius: "50%",
          minWidth: 17, height: 17, fontSize: 10, fontWeight: 700,
          display: "flex", alignItems: "center", justifyContent: "center", padding: "0 4px",
        }}>{count}</span>
      )}
    </span>
  );
}

export function AccessDenied() {
  return (
    <div style={{ padding: 40, textAlign: "center", color: "#dc2626" }}>
      <div style={{ fontSize: 32 }}>🔒</div>
      <div style={{ marginTop: 12, fontWeight: 600 }}>Access denied</div>
    </div>
  );
}

export function OffersPageWrapper() {
  const [params] = useSearchParams();
  const candidateId = params.get("candidate_id") ? Number(params.get("candidate_id")) : undefined;
  const offerId = params.get("offer_id") ? Number(params.get("offer_id")) : undefined;
  return <OffersPage initialCandidateId={candidateId} initialOfferId={offerId} />;
}
